











































import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';

@Component({
  components: {
    FmvAvatar,
  },
})
export default class WriteThroughChatbot extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: true, default: null}) readonly public userId: number | null;
  public loadingState = {
    submit: false,
  };
  public telegramMessage: string = '';

  public resetForm() {
    this.telegramMessage = '';
    this.$emit('close-modal');
  }

  public async handleSubmit() {
    this.loadingState.submit = true;
    const data = {
      user_id: Number(this.userId),
      text: this.telegramMessage,
    };
    try {
      const response = await api.sendMsgThroughChatbot(this.$store.getters.token, data);
      // @ts-ignore
      this.showToast(this, this.$t('Message sent successfuly'));
      this.$emit('message-created');
      this.resetForm();
    // @ts-ignore
    } catch (e: any) {
      if (e.response && e.response.data.error) {
        // @ts-ignore
        this.showToast(this, e.response.data.error, 'error');
      } else if (e.response && e.response.data.user_id) {
        // @ts-ignore
        this.showToast(this, e.response.data.user_id[0], 'error');
      } else if (e.response && e.response.data.text) {
        // @ts-ignore
        this.showToast(this, e.response.data.text[0], 'error');
      } else {
        // @ts-ignore
        this.showToast(this, this.$t('Error'), 'error');
      }
    }
    this.loadingState.submit = false;
  }
}
